import styled from 'styled-components';

export const Container = styled.main``;

export const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #f2f5f9;
  width: 500px;
  max-height: 80vh;
  padding: 10px;
  border: 2px solid #fff;
  border-radius: 10px;

  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  gap: 10px;
  flex: 1;

  a {
    color: #14a79c;
  }

  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.05);
    width: 100%;
    border-radius: 5px;
    height: 40px;
  }

  @media (max-width: 450px) {
    width: 300px;
  }

  @media (max-width: 350px) {
    width: 250px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 20px;

  background: transparent;
  border: none;
  border-radius: 50%;

  height: 20px;
  width: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0px 0px 10px #fff;
  }

  svg {
    color: #fff;
    pointer-events: none;
  }
`;

export const SubjectLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  width: 100%;
  margin-bottom: 7.5px;

  input {
    height: 40px;
    border-radius: 5px;
    border: none;
    padding: 5px;
    width: 100%;
  }

  & > div {
    background: white;
    width: 100%;
  }
`;

export const MessageBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  width: 100%;

  textarea {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: none;
    padding: 5px;
    resize: none;

    @media (max-width: 1000px) {
      resize: vertical;
    }
  }
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  background-color: #3dd4cbaa;
  color: #fff;
  border-radius: 10px;
  border: none;
  font-weight: 500;
  padding: 5px;
  margin-top: 10px;

  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`;
